<template>
  <div class="border rounded-lg shadow-ts9 h-fit" :class="cardBorder()">
    <div class="w-full h-[66px] rounded-md relative mb-14" :class="cardBgColor()">
      <div class="absolute w-full top-[33px] flex justify-center">
        <div class="w-[60px] h-[60px] rounded-full bg-white">
          <img :src="getPrizeIcon()" alt="Price pool competition">
        </div>
      </div>
    </div>
    <div class="px-3">
      <div class="text-center">
        <h3 class="font-semibold text-[20px] lg:text-[18px]"
          :class="[type === 'inprogress' ? 'text-blue' : 'text-gray-900 h-[52px]']">{{ competition.name }}</h3>
        <h3 class="font-semibold text-[22px] text-gray-900 mt-1">${{ competition.prizes.reduce((sum, item) => sum +
          Number(item), 0) }}</h3>
        <p class="text-sm text-gray-900 mt-1">{{ $t('grand_price') }}</p>
      </div>
      <!-- Card content when the competition is finished -->
      <div v-if="type === 'finished'" class="mt-6">
        <div class="w-full text-center pt-4 pb-[8px] bg-[#2d394b1a] rounded-lg">
          <div class="flex items-center justify-center gap-x-1 relative mb-2">
            <p class="text-sm text-gray-900 text-center">{{ $t('comp_ended') }}</p>
            <!-- Tooltip for desktop -->
            <div @mouseover="finishedTooltipOpen = true" @mouseleave="finishedTooltipOpen = false"
              class="hidden lg:block">
              <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
            </div>
            <!-- Bottom Sheet for mobile -->
            <div
              @click="() => { showBottomSheet = true; enterCompetitionErrorMessage = $t('comp_ended_msg'); bottomSheetTitle = $t('comp_ended') }"
              class="block lg:hidden">
              <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
            </div>
            <!-- Tooltip when opened -->
            <div v-if="finishedTooltipOpen" class="w-full absolute top-10 left-0 z-[1]">
              <div
                class="font-body text-base leading-7 text-gray-900 text-left font-normal m-auto lg:m-0 lg:float-right bg-white rounded-lg shadow-ts3 w-11/12 max-w-[348px] p-5 object-right-bottom">
                {{ $t('comp_ended_msg') }}
              </div>
            </div>
          </div>
          <h3 class="text-gray-900 font-semibold text-[20px]">
            {{ $moment(this.competition.end_date).format('MMMM D, YYYY') }}
          </h3>
        </div>
        <div v-if="finishedCardExpanded" class="inline-grid grid-cols-2 grid-rows-2 gap-2 w-full mt-5">
          <StatisticsCards v-for="statistic in statisticsCards" :key="statistic.id" :item="statistic" :type="type" />
        </div>
        <div class="mt-4">
          <button @click="leaderboardClick" :disabled="competitionStarted"
            class="w-full bg-white text-center text-gray-900 text-base font-medium border border-gray-500 rounded-md py-3 px-3 md:mt-5 lg:mt-0 table lg:block">
            {{ $t('leaderboard') }}
          </button>
          <div class="flex justify-center">
            <img @click="finishedCardExpanded ? finishedCardExpanded = false : finishedCardExpanded = true"
              :src="finishedCardExpanded ? require('../../assets/img/icons/competitions/arrow-up.svg') : require('../../assets/img/icons/competitions/arrow-down.svg')"
              class="my-2 cursor-pointer" width="22" height="22" alt="Arrow Up Down">
          </div>
        </div>
      </div>
      <!-- Card content when the competition is upcoming -->
      <div v-else-if="type === 'upcoming'" class="">
        <div class="inline-grid grid-cols-2 grid-rows-2 gap-2 w-full mt-5">
          <StatisticsCards v-for="statistic in statisticsCards" :key="statistic.id" :item="statistic" :type="type" />
        </div>
        <div class="w-full text-center pt-4 pb-[34px] rounded-lg">
          <div class="flex items-center justify-center gap-x-1 relative mb-2">
            <p class="text-sm text-gray-900 text-center">{{ $t('comp_starts') }}</p>
            <!-- Tooltip for desktop -->
            <div @mouseover="upcomingTooltipOpen = true" @mouseleave="upcomingTooltipOpen = false"
              class="hidden lg:block">
              <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
            </div>
            <!-- Bottom Sheet for mobile -->
            <div
              @click="() => { showBottomSheet = true; enterCompetitionErrorMessage = $t('comp_starts_msg'); bottomSheetTitle = $t('upcoming_comp') }"
              class="block lg:hidden">
              <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
            </div>
            <!-- Tooltip when opened -->
            <div v-if="upcomingTooltipOpen" class="w-full absolute top-10 left-0 z-[1]">
              <div
                class="font-body text-base leading-7 text-gray-900 text-left font-normal m-auto lg:m-0 lg:float-right bg-white rounded-lg shadow-ts3 w-11/12 max-w-[348px] p-5 object-right-bottom">
                {{ $t('comp_starts_msg') }}
              </div>
            </div>
          </div>
          <h3 class="text-gray-900 font-semibold text-[20px]">
            {{ $moment(this.competition.start_date).format('MMMM D, YYYY') }}
          </h3>
        </div>
        <div class="w-full flex items-center gap-x-2 mb-5">
          <button :disabled="true"
            class="w-[55%] bg-[#C9C9C9] text-center text-white text-base font-bold rounded-md py-3 px-3 md:mt-5 lg:mt-0 table lg:block">
            {{ $t('enter_competition') }}
          </button>
          <button :disabled="true"
            class="w-[45%] bg-white text-center text-gray-900 text-opacity-50 text-base font-medium border border-gray-500 rounded-md py-3 px-3 md:mt-5 lg:mt-0 table lg:block">
            {{ $t('leaderboard') }}
          </button>
        </div>
        <div class="mb-5 flex justify-center">
          <span @click="$emit('openRules')" class="text-gray-900  text-sm underline cursor-pointer">{{ $t('view_rules')
            }}</span>
        </div>
        <div class="mb-5 flex justify-center">
          <div class="form-check relative flex items-center">
            <input class="checkbox pointer-events-none" v-validate="'required'" :disabled="true" type="checkbox"
              v-model="acceptTCS" :id="'acceptTCS-' + competition.id" style="width:20px;height:20px;" />
            <label class="text-xs text-[#C9C9C9] pointer-events-none" :for="'acceptTCS-' + competition.id"
              :id="'acceptCompetitionTCS-' + competition.id"
              v-html="$t('agree_with_competition_tcs', { URL: competitionTCsURL })"> </label>
          </div>
        </div>
      </div>
      <!-- Card content when the competition is in progress -->
      <div v-else>
        <div class="inline-grid grid-cols-2 grid-rows-2 gap-2 w-full mt-5">
          <StatisticsCards v-for="statistic in statisticsCards" :key="statistic.id" :item="statistic" :type="type" />
        </div>
        <!-- Already in competition -->
        <div class="w-full flex items-center justify-center gap-x-1 relative pt-8 pb-6 md:py-[49px]"
          v-if="hasEnteredComp">
          <p class="text-base text-center font-medium text-gray-600">{{ $t('already_in_comp') }}</p>
          <!-- Tooltip for desktop -->
          <div @mouseover="fullyBookedTooltipOpen = true" @mouseleave="fullyBookedTooltipOpen = false"
            class="hidden lg:block">
            <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
          </div>
          <!-- Bottom Sheet for mobile -->
          <div
            @click="() => { showBottomSheet = true; enterCompetitionErrorMessage = $t('already_in_msg'); bottomSheetTitle = $t('already_in_msg_title') }"
            class="block lg:hidden">
            <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
          </div>
          <!-- Tooltip when opened -->
          <div v-if="fullyBookedTooltipOpen" class="w-full absolute top-[80px] left-0 z-[1]">
            <div
              class="font-body text-base leading-7 text-gray-900 text-left font-normal m-auto lg:m-0 lg:float-right bg-white rounded-lg shadow-ts3 w-11/12 max-w-[348px] p-5 object-right-bottom">
              {{ $t('already_in_msg') }}
            </div>
          </div>
        </div>
        <!-- Can Enter Competition -->
        <div class="my-4 px-5"
          v-if="(competition.contestants_count < competition.max_contestants) && timeRemaining && !hasEnteredComp">
          <RemainingTime :targetDate="targetDate" />
        </div>
        <!-- Fully booked -->
        <div class="w-full flex items-center justify-center gap-x-1 relative pt-8 pb-6 md:py-[49px]"
          v-else-if="((competition.contestants_count >= competition.max_contestants) && timeRemaining || (competition.contestants_count >= competition.max_contestants) && !timeRemaining) && !hasEnteredComp">
          <p class="text-base text-center font-medium text-gray-600">{{ $t('fully_booked') }}</p>
          <!-- Tooltip for desktop -->
          <div @mouseover="fullyBookedTooltipOpen = true" @mouseleave="fullyBookedTooltipOpen = false"
            class="hidden lg:block">
            <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
          </div>
          <!-- Bottom Sheet for mobile -->
          <div
            @click="() => { showBottomSheet = true; enterCompetitionErrorMessage = $t('fully_booked_msg'); bottomSheetTitle = $t('fully_booked_msg_title') }"
            class="block lg:hidden">
            <img class="w-[13px] h-[13px]" src="../../assets/img/icons/upload/info.svg" alt="Additional info" />
          </div>
          <!-- Tooltip when opened -->
          <div v-if="fullyBookedTooltipOpen" class="w-full absolute top-[80px] left-0 z-[1]">
            <div
              class="font-body text-base leading-7 text-gray-900 text-left font-normal m-auto lg:m-0 lg:float-right bg-white rounded-lg shadow-ts3 w-11/12 max-w-[348px] p-5 object-right-bottom">
              {{ $t('fully_booked_msg') }}
            </div>
          </div>
        </div>
        <!-- No Time to enter competition -->
        <div
          v-else-if="(competition.contestants_count < competition.max_contestants) && !timeRemaining && !hasEnteredComp"
          class="my-4 px-5">
          <RemainingTime :empty="true" :hasTooltip="true" />
        </div>
        <div class="w-full flex items-center gap-x-2 mb-5">
          <button @click="enterCompetitionClick"
            :disabled="(competition.contestants_count < competition.max_contestants) && timeRemaining && competitionStarted && isSameMonth && !hasEnteredComp ? false : true"
            :class="[(competition.contestants_count < competition.max_contestants) && timeRemaining && competitionStarted && isSameMonth && !hasEnteredComp ? 'bg-green' : 'bg-[#C9C9C9]']"
            class="w-[55%]  text-center text-white text-base font-bold rounded-md py-3 px-3 md:mt-5 lg:mt-0 table lg:block">
            {{ $t('enter_competition') }}
          </button>
          <button @click="leaderboardClick" :disabled="isUpcoming"
            class="w-[45%] bg-white text-center text-gray-900 text-base font-medium border border-gray-500 rounded-md py-3 px-3 md:mt-5 lg:mt-0 table lg:block">
            {{ $t('leaderboard') }}
          </button>
        </div>
        <div class="mb-5 flex justify-center">
          <span @click="$emit('openRules')" class="text-gray-900  text-sm underline cursor-pointer">{{ $t('view_rules')
            }}</span>
        </div>
        <div class="mb-5 flex justify-center">
          <div class="form-check relative flex items-center">
            <input class="checkbox" v-validate="'required'"
              :class="[acceptTCS === false ? 'appearance-none' : '', (competition.contestants_count < competition.max_contestants) && timeRemaining && competitionStarted && isSameMonth && !hasEnteredComp ? '' : 'pointer-events-none']"
              :disabled="(competition.contestants_count < competition.max_contestants) && timeRemaining && competitionStarted && isSameMonth && !hasEnteredComp ? false : true"
              type="checkbox" v-model="acceptTCS" :id="'acceptTCS-' + competition.id" style="width:20px;height:20px;" />
            <label class="text-xs text-gray-900"
              :class="[(competition.contestants_count < competition.max_contestants) && timeRemaining && competitionStarted && isSameMonth && !hasEnteredComp ? 'text-gray-900' : 'text-[#C9C9C9] pointer-events-none']"
              :for="'acceptTCS-' + competition.id" :id="'acceptCompetitionTCS-' + competition.id"
              v-html="$t('agree_with_competition_tcs', { URL: competitionTCsURL })"> </label>
          </div>
        </div>
      </div>
    </div>







    <!-- Competition finished -->
    <!-- Was here -->


    <BottomSheet :isOpen="showBottomSheet" :title="bottomSheetTitle" height="auto" @close="showBottomSheet = false">
      <p class="text-gray-700">{{ enterCompetitionErrorMessage }}</p>
    </BottomSheet>
  </div>
</template>

<script>
import StatisticsCards from './shared-components/StatisticsCards.vue'
import RemainingTime from './shared-components/RemainingTime.vue'
import BottomSheet from '@/components/reusableComponents/BottomSheet.vue'
import links from '../../config/links'
import moment from "moment-jalaali";

import { mapGetters } from 'vuex'

export default {
  name: 'competition-card',
  props: {
    competition: Object,
    openRules: Function,
    type: {
      type: String,
      default: 'inprogress'
    }
  },
  data() {
    return {
      statisticsCards: [
        { id: 'comp_start', title: '', icon: require('@/assets/img/icons/competitions/time-remaining.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' },
        { id: 'comp_end', title: '', icon: require('@/assets/img/icons/competitions/current-leader.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' },
        { id: 'reg_end', title: '', icon: require('@/assets/img/icons/competitions/registration-ends.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' },
        { id: 'contestants', title: '', icon: require('@/assets/img/icons/competitions/contestants.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' },
      ],
      enterCompetitionErrorMessage: "",
      fullyBookedTooltipOpen: false,
      finishedTooltipOpen: false,
      showBottomSheet: false,
      bottomSheetTitle: '',
      acceptTCS: false,
      finishedCardExpanded: false,
      upcomingTooltipOpen: false
    }
  },
  components: {
    StatisticsCards,
    RemainingTime,
    BottomSheet,
  },
  created(){
    if(this.Language === 'fa') {
      moment.loadPersian(); // Enable Persian support
    }
  },
  mounted() {
    this.populateStatisticsCards()
  },
  computed: {
    targetDate() {
      // Generate target date as 15th of the current month
      var date = moment(this.competition.end_date).date(15).format('YYYY-MM-DD')
      var dateTime = new Date(date + ' 23:59:59')

      return (moment(dateTime).format('YYYY-MM-DD HH:mm:ss'))
    },
    timeRemaining() {
      const now = moment();
      const target = moment(this.targetDate, "YYYY-MM-DD HH:mm:ss") //moment(this.competition.start_date).date(15);
      const duration = moment.duration(target.diff(now));
      return duration > 0 ? true : false
    },
    competitionStarted() {
      return moment(this.competition.start_date) <= moment() && moment(this.competition.start_date).isSame(moment(), 'month')
    },
    hasEnteredComp() {
      if (this.competition.id == this.Comp.id && this.Entered) {
        return true
      } else return false
    },
    isSameMonth() {
      return moment(this.competition.start_date).isSame(moment(), 'month')
    },
    isUpcoming() {
      return moment(this.competition.start_date) > moment()
    },
    competitionTCsURL() {
      return links.getLink('competitionTCsURL', 'en')
    },
    ...mapGetters({
      Language: 'language/code',
      Comp: 'competition/currentCompetition',
      Entered: 'competition/hasEnteredCurrentCompetition',
      User: 'user/all',
    }),
  },
  watch: {
    Language() {
      this.populateStatisticsCards()
    },
  },
  methods: {
    populateStatisticsCards() {
      this.statisticsCards.map(statistic => {
        switch (statistic.id) {
          case 'comp_start':
            statistic.title = this.$t('comp_starts')
            statistic.statisticTime = moment(this.competition.start_date).format('LT')
            statistic.statisticValueDate = moment(this.competition.start_date).format('MMM D, YYYY')
            if (this.type === 'finished' || this.type === 'upcoming') {
              statistic.icon = require('@/assets/img/icons/competitions/time-remaining-fin.svg')
            }
            break
          case 'comp_end':
            statistic.title = this.$t('comp_ends')
            statistic.statisticTime = moment(this.competition.end_date).format('LT')
            statistic.statisticValueDate = moment(this.competition.end_date).format('MMM D, YYYY')
            if (this.type === 'finished' || this.type === 'upcoming') {
              statistic.icon = require('@/assets/img/icons/competitions/competition-ends-fin.svg')
            }
            break
          case 'reg_end':
            statistic.title = this.$t('reg_ends')
            statistic.statisticValueDate = moment(this.competition.start_date).date(15).format('MMM D, YYYY')
            if (this.type === 'finished' || this.type === 'upcoming') {
              statistic.icon = require('@/assets/img/icons/competitions/registration-ends-fin.svg')
            }
            break
          case 'contestants':
            statistic.title = this.$t('contestants')
            statistic.statisticValueNumber = this.competition.contestants_count || 0
            if (this.type === 'finished' || this.type === 'upcoming') {
              statistic.icon = require('@/assets/img/icons/competitions/contestants-fin.svg')
            }
            break
        }
      })
    },
    enterCompetitionClick() {
      if (this.acceptTCS == false) {
        let el = document.getElementById('acceptCompetitionTCS-' + this.competition.id)
        el.classList.add('checkbox-label-required')
        return
      }
      this.$router.push({ name: 'Enter Competition', query: { competition: JSON.stringify(this.competition) } })
    },
    leaderboardClick() {
      this.$router.push({ name: 'Leaderboard', query: { competition: JSON.stringify(this.competition) } })
    },
    cardBgColor() {
      if (this.type === 'inprogress') {
        return 'bg-blue border-blue'
      } else if (this.type === 'finished') {
        return 'bg-gray-900 border-gray-300'
      } else if (this.type === 'upcoming') {
        return 'bg-gold border-gold'
      }
    },
    cardBorder() {
      if (this.type === 'inprogress') {
        return 'border-blue'
      } else if (this.type === 'finished') {
        return 'border-gray-300'
      } else if (this.type === 'upcoming') {
        return 'border-gold'
      }
    },
    getPrizeIcon() {
      if (this.type === 'inprogress') {
        return require('@/assets/img/icons/competitions/prize-pool-competition-main-icon.svg')
      } else if (this.type === 'finished') {
        return require('@/assets/img/icons/competitions/prize-pool-competition-main-icon-finished.svg')
      } else if (this.type === 'upcoming') {
        return require('@/assets/img/icons/competitions/prize-pool-competition-main-icon-upcoming.svg')
      }
    },
  },
}
</script>
